import { render, staticRenderFns } from "./SortFilter.vue?vue&type=template&id=48432371&scoped=true"
import script from "./SortFilter.vue?vue&type=script&lang=js"
export * from "./SortFilter.vue?vue&type=script&lang=js"
import style0 from "./SortFilter.vue?vue&type=style&index=0&id=48432371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48432371",
  null
  
)

export default component.exports